import Image from "next/image"
import { classNames } from "core/utils"
import { RadioGroup } from "@headlessui/react"
import { getPrice } from "@lib/swell/storefront-data-hooks/src/utils/product"
import { OptionValue, ProductOption } from "@lib/swell/storefront-data-hooks/src/types"

export interface RadioWithImageBgInputProps {
  option: ProductOption
  optionValues?: Readonly<Array<OptionValue>>
  onChange?: any
  selected?: string
}

const RadioWithImageBg: React.FC<RadioWithImageBgInputProps> = ({
  option,
  optionValues,
  onChange,
  selected,
}) => {
  const { name, description } = option
  const selectedOption = optionValues?.find((option) => option.name === selected)
  return (
    <div className="rounded-lg border border-gray-300 p-4">
      <h3 className="text-sm font-medium text-gray-900">{name}</h3>

      <RadioGroup value={selected} onChange={onChange} className="mt-4">
        <RadioGroup.Label className="sr-only">{name}</RadioGroup.Label>
        <RadioGroup.Description as="span" className="text-sm text-gray-500">
          {option.description}
        </RadioGroup.Description>

        <div className="mt-4 flex items-center space-x-3">
          {optionValues?.map((option) => (
            <RadioGroup.Option
              key={option.id}
              value={option.name}
              className={({ active, checked }) =>
                classNames(
                  active && checked ? "ring-3 ring-offset-1" : "",
                  !active && checked ? "ring-2" : "",
                  "relative -m-0.5 flex cursor-pointer items-center justify-center overflow-hidden rounded-full p-0.5 focus:outline-hidden"
                )
              }
            >
              <RadioGroup.Label as="p" className="sr-only">
                {option.name}
              </RadioGroup.Label>
              {option.option_value_image?.url && (
                <img
                  src={option.option_value_image.url}
                  alt={option.name}
                  className={classNames(
                    "h-20 w-20 rounded-full border border-black border-opacity-10"
                  )}
                />
              )}
            </RadioGroup.Option>
          ))}
        </div>
      </RadioGroup>

      <div className="mt-6 border-t-2 border-t-gray-500">
        <div className="mt-2 grid grid-cols-4 space-y-2">
          <div className="col-span-4 text-sm text-gray-600">{selectedOption?.description}</div>
          <div className="col-span-1 text-sm">{selectedOption?.name}</div>
          <div className="col-span-1" />
          <div className="col-span-1" />
          <div className="col-span-1 text-sm">
            {selectedOption?.price ? getPrice(selectedOption?.price, "usd") : "Included"}
          </div>
        </div>
      </div>
    </div>
  )
}

export default RadioWithImageBg
